import { styled } from '@mui/material/styles';
import NavBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link } from '@mui/material';
import { withRouter } from 'react-router';

// Style the navbar
const MyNavBar = styled(NavBar)(({ theme }) => ({
    flexGrow: 1,
    background: 'linear-gradient(90deg, rgb(0, 113, 242) 0%, rgb(0, 178, 180) 73.41%, rgb(0, 202, 157) 100%)'
}));

// Style the link
const MyLink = styled(Link)(({ theme }) => ({
    backgroundColor: 'rgba(26, 32, 38, 0.12)',
    marginLeft: 30,
    color: '#ffffff',
    padding: 21,
    '&:hover': {
        backgroundColor: 'rgba(26, 32, 38, 0.06)'
    },
    cursor: 'pointer'
}));



const AppBar = (props) => {
    const onLinkClick = () => {
        props.history.push(`/apiDocumentation`);
    };


    return (
        <MyNavBar position="static">
            <Toolbar>
                <Typography variant="h6">Developers</Typography>
                <MyLink onClick={onLinkClick}> API Documentation </MyLink>


            </Toolbar>
        </MyNavBar>
    );
};

export default withRouter(AppBar);
